// extracted by mini-css-extract-plugin
export default {"fleetRisk":"carScore_fleetRisk__6ukYv","searchBox":"carScore_searchBox__Y8LLT"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"fleetRisk\":\"carScore_fleetRisk__6ukYv\",\"searchBox\":\"carScore_searchBox__Y8LLT\"}";
        // 1793760837625
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  